import { E as c } from "./react-error-boundary.esm-DsUx8ONQ.js";
import { c as l } from "./react-error-boundary.esm-DsUx8ONQ.js";
import o from "react";
import r from "react-dom";
function f({
  rootComponent: t
}) {
  const n = t;
  return () => ({
    async render({ dom: e, fallback: m, ...a }) {
      r.render(
        /* @__PURE__ */ o.createElement(c, { FallbackComponent: m }, /* @__PURE__ */ o.createElement(
          n,
          {
            ...a
          }
        )),
        e
      );
    },
    async destroy({ dom: e }) {
      r.unmountComponentAtNode(e);
    }
  });
}
export {
  f as createBridgeComponent,
  l as createRemoteComponent
};
